import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Alert, AlertDescription } from "@/components/ui/alert";

/**
 * Empty state shown in a meeting sheet when the meeting was not recorded.
 *
 * The backend resolves a human-readable reason (host denied the request, bot
 * kicked from the call, stuck in the waiting room, etc.) into
 * `Engagement.transcriptStatusMessage` via its FRIENDLY_MESSAGES map. When that
 * message is present we render it verbatim; otherwise we fall back to the
 * generic line. Mirrors the legacy coffee-ui behaviour.
 */
export function MeetingNotRecorded({ message }: { message?: string | null }) {
  const { t } = useTranslation();
  const reason = message?.trim();
  return (
    <div className="py-16 text-center text-sm text-muted-foreground">
      {reason || t("meetings.notRecorded")}
    </div>
  );
}

/**
 * Info banner shown inside the Recording tab when a meeting *was* recorded but
 * the bot was kicked before the call ended, leaving only a partial transcript.
 * Gated on `Engagement.transcriptIncomplete`; the explanatory text comes from
 * the same `transcriptStatusMessage` field.
 */
export function MeetingTranscriptIncompleteNote({
  message,
  incomplete,
}: {
  message?: string | null;
  incomplete?: boolean | null;
}) {
  const reason = message?.trim();
  if (!incomplete || !reason) return null;
  return (
    <Alert>
      <AlertTriangle className="h-4 w-4" />
      <AlertDescription>{reason}</AlertDescription>
    </Alert>
  );
}
